var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.9165V21.6665",
    stroke: "#FF8B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1334 14.3002V25.7002C35.1334 27.5668 34.1334 29.3002 32.5167 30.2502L22.6167 35.9669C21 36.9002 19 36.9002 17.3667 35.9669L7.46665 30.2502C5.84999 29.3169 4.84998 27.5835 4.84998 25.7002V14.3002C4.84998 12.4336 5.84999 10.7002 7.46665 9.75015L17.3667 4.0335C18.9833 3.10016 20.9834 3.10016 22.6167 4.0335L32.5167 9.75015C34.1334 10.7002 35.1334 12.4169 35.1334 14.3002Z",
    stroke: "#FF8B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27V27.1667",
    stroke: "#FF8B00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b2f8678987d04f873cb1e8f6baae1abc.svg";
export { ForwardRef as ReactComponent };